import { createSlice } from '@reduxjs/toolkit';

export const vooksCountdownSlice = createSlice({
  name: 'vooksCountdown',
  initialState: {
    count: 57,
  },
  reducers: {
    init: (state) => {
      state.count = 57;
    },
    countUp: (state, action) => {
      state.count = state.count + action.payload;
    },
  },
});

export const initAsync = () => async (dispatch) => {
  try {
    dispatch(init());
  } catch (error) {
    throw new Error(error);
  }
};

export const countUpAsync = (data) => async (dispatch) => {
  try {
    dispatch(countUp(data.randomNumber));
  } catch (error) {
    throw new Error(error);
  }
};

export const {
  init,
  countUp,
} = vooksCountdownSlice.actions;

export default vooksCountdownSlice.reducer;
